import React from 'react';

const EmailIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
    >
      <g clipPath="url(#clip0_3074_57218)">
        <path
          d="M12.6667 0.666992H3.33333C2.4496 0.668051 1.60237 1.01958 0.97748 1.64447C0.352588 2.26936 0.00105857 3.1166 0 4.00033L0 12.0003C0.00105857 12.8841 0.352588 13.7313 0.97748 14.3562C1.60237 14.9811 2.4496 15.3326 3.33333 15.3337H12.6667C13.5504 15.3326 14.3976 14.9811 15.0225 14.3562C15.6474 13.7313 15.9989 12.8841 16 12.0003V4.00033C15.9989 3.1166 15.6474 2.26936 15.0225 1.64447C14.3976 1.01958 13.5504 0.668051 12.6667 0.666992V0.666992ZM3.33333 2.00033H12.6667C13.0659 2.00111 13.4557 2.12134 13.786 2.34553C14.1163 2.56972 14.3719 2.88762 14.52 3.25833L9.41467 8.36433C9.03895 8.73853 8.53028 8.94864 8 8.94864C7.46972 8.94864 6.96105 8.73853 6.58533 8.36433L1.48 3.25833C1.6281 2.88762 1.88374 2.56972 2.21403 2.34553C2.54432 2.12134 2.93414 2.00111 3.33333 2.00033V2.00033ZM12.6667 14.0003H3.33333C2.8029 14.0003 2.29419 13.7896 1.91912 13.4145C1.54405 13.0395 1.33333 12.5308 1.33333 12.0003V5.00033L5.64267 9.30699C6.26842 9.93116 7.11617 10.2817 8 10.2817C8.88383 10.2817 9.73158 9.93116 10.3573 9.30699L14.6667 5.00033V12.0003C14.6667 12.5308 14.456 13.0395 14.0809 13.4145C13.7058 13.7896 13.1971 14.0003 12.6667 14.0003Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3074_57218">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmailIcon;
